import { createVNode as a, mergeProps as n } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FileRarTwotoneStandard.js";
import d from "../components/PfIcon.js";
const r = (t, o) => {
  const e = {
    ...t,
    ...o.attrs
  };
  return a(d, n(e, {
    icon: i
  }), null);
};
r.displayName = "FileRarTwotoneStandard";
r.inheritAttrs = !1;
export {
  r as default
};
